import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import ApiConfig from 'src/config/api-config.ts';

interface JoinWaitlistParams {
  email: string;
  type: 'mover' | 'trainer';
}

export interface ApiError {
  error?: {
    code: string;
    field?: string | string[];
    message: string;
  };
}

export function useJoinWaitlist() {
  return useMutation({
    mutationFn: async (params: JoinWaitlistParams) => {
      const response = await axios.post(
        `${ApiConfig.BASE_URL}${ApiConfig.WAITLIST_API_HOST}`,
        params,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
      return response.data;
    },
  });
}
